import { IOptionItem } from '@ui-lib/components';
import { FormControl } from '@angular/forms';
import { AgentStatuses } from '../../core/openapi/bff-admin-api';

export interface AgentsFiltersForm {
  keyword: FormControl<string>;
  facilityIds: FormControl<string[]>;
  statusIds: FormControl<number[]>;
  approval: FormControl<IOptionItem<boolean> | null>;
}

export interface IPaginationState {
  pageIndex: number;
  pageSize: number;
}

export interface IAgentsTableData {
  items: ISearchAgentsItem[];
  totalCount: number;
}

export interface ISearchAgentsItem {
  id: string;
  name: string;
  facilityId?: string | null;
  facilityName?: string | null;
  status: AgentStatuses;
  comment?: string | null;
  version?: string | null;
  lastHeartbeatAt?: string | null;
  createdDate: string;
  isApproved: boolean;
}

export enum ModalAction {
  APPROVE = 'approve',
  EDIT = 'edit',
}
